import { useMemo } from 'react';
import get from 'lodash/get';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getAuthenticateUser } from '../../../../store/authenticate/selectors';
import { getManagerPermissions } from '../../../../store/settings/selectors';
import { usePermissions } from '../../../../hooks/useCommon';

export function useTasklistPermissions() {
  const { personnel } = useAppSelector(getAuthenticateUser);
  const settings = useAppSelector(getManagerPermissions);
  const { permissions: localPermissions } = usePermissions();

  const tasklistPermissions = useMemo(() => ({
    isAllowManage: (!localPermissions.isEmployee && get(settings, 'actions.tasklists.manage')) || localPermissions.isAdmin,
    isAllowViewTasklist: (!localPermissions.isEmployee && get(settings, 'visibility.tasklists.view')) || localPermissions.isAdmin,
  }), [personnel.permissionLevel, settings]);

  return {
    tasklistPermissions,
  };
}
